<button
  [class]="
    'flex w-full h-9 -my-[0.375rem] justify-between items-center cursor-pointer group hover:text-primary ' +
    (isExpanded ? 'text-primary' : '')
  "
  (click)="toggled.emit()"
>
  <div class="flex items-center gap-2">
    @if (titleIconName) {
      <rkt-icon [name]="titleIconName" class="text-xl group-hover:scale-110"></rkt-icon>
    }

    @if (title) {
      <div class="text-font-primary font-bold text-base">{{ title }}</div>
    }
  </div>

  <rkt-icon
    [class]="'text-2xl transition-transform ease-in-out duration-100 ' + (isExpanded ? 'rotate-180' : '')"
    name="chevron-down"
  ></rkt-icon>
</button>

<div
  [class]="
    'pl-7 relative transition-[max-height] ease-in-out duration-100 max-h-0 ' + (isExpanded ? '!max-h-[624.9375rem]' : 'overflow-hidden')
  "
>
  <div class="mt-5">
    <ng-content></ng-content>
  </div>
</div>
